export const ManageScopes = () => {
    return (
        <div>

        </div>
    )
}